import { Controller } from "stimulus"

const GA_TAG_ID = "AW-347129426"
const COOKIE_NAME = "cookie_consent"

export default class extends Controller {
  connect() {
    if (!this._getConsent()) {
      this.element.style.display = "block"
    }
  }

  accept() {
    this._setConsent("accepted")
    this._injectGA()
    this.element.style.display = "none"
  }

  decline() {
    this._setConsent("declined")
    this.element.style.display = "none"
  }

  _getConsent() {
    return document.cookie.split("; ").find(row => row.startsWith(COOKIE_NAME + "="))
  }

  _setConsent(value) {
    document.cookie = `${COOKIE_NAME}=${value}; max-age=31536000; path=/; SameSite=Lax`
  }

  _injectGA() {
    const script = document.createElement("script")
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TAG_ID}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    function gtag() { window.dataLayer.push(arguments) }
    window.gtag = gtag
    gtag("js", new Date())
    gtag("config", GA_TAG_ID)
  }
}
